module.exports = __webpack_public_path__ + "img/Banner-Plantilla-mediano-2.40a6eb86.png";